import { createAction } from 'redux-actions';

export const requestGetFormTemplateAction = createAction('REQUEST/GET_FORM_TEMPLATE');
export const requestPutFormTemplateAction = createAction('REQUEST/PUT_FORM_TEMPLATE');
export const requestPostFormTemplateAction = createAction('REQUEST/POST_FORM_TEMPLATE');
export const requestDeleteFormTemplateAction = createAction('REQUEST/DELETE_FORM_TEMPLATE');
export const setFormTemplateDrawerOpenedAction = createAction('SET_FORM_TEMPLATE_DRAWER_OPENED');
export const resetFormTemplateDataAction = createAction('RESET_FORM_TEMPLATE_DATA_OPENED');
